<template>
    <section class="section">
        <div class="container">
            <PageHeader title="Нова нарачка">
                <div class="level-item" v-if="order">

                  <div class="tags">
                        <span class="tag " :title="status.created_at | statusTime"  :class="status | statusClass" v-for="status in order.statuses" :key="status.status">{{status | status}}</span>
                    </div>
                </div>
            </PageHeader>
            <div class="columns is-multiline">
                <div class="column is-8-desktop is-full-touch">
                    <div v-for="(p,i) in products" v-bind:key="p.id" class="card">
                        <header class="card-header" v-if="allAvailable || p.variants.some(v=> v.can_order || getItemQuantity(v))"
                                @click="clickProduct(i, $event)">
                            <p class="card-header-title ">
                                <span class="tag is-medium is-white is-size-4-tablet is-size-6-desktop" v-bind:class="{'is-success': getItemCalc(p).quantity}">
                                    {{p.name}}
                                </span>
                            </p>
                            <p class="card-header-icon">
                                <span class="tag is-medium is-rounded"
                                      v-bind:class="{'is-success': getItemCalc(p).quantity}">
                                    <b>{{getItemCalc(p).quantity}} ставки: {{getItemCalc(p).sum}} ден</b>
                                </span>

                            </p>

                        </header>
                        <div class="card-content"
                             v-show="activeProduct===i && (allAvailable || p.variants.some(v=> v.can_order || getItemQuantity(v)))">
                            <div class="columns  is-multiline">
                                <EditOrderVariant
                                        :allAvailable="allAvailable"
                                        :price="getItemPrice(v)"
                                        :quantity="getItemQuantity(v)"
                                        v-bind:key="v.id" v-for="v in p.variants"
                                        :variant="v"
                                        :can_edit="order.can_edit"
                                        @setItem="setItem"
                                        :itemCache="itemsCache.find(a=> a.variant_id === v.id)"
                                        @setItemQuantity="setItemQuantity"
                                />
                            </div>
                        </div>
                    </div>
                    <Loading variant="is-light" v-if="!products.length"/>
                    <div class="card">
                        <div class="card-footer">
                            <div class="card-footer-item" style="flex-grow:initial">
                              <button @click="allAvailable = !allAvailable" class="button is-small is-block" :class="{'is-danger': allAvailable}">
                                <span class="icon"><i class="fa" :class="{'fa-check': !allAvailable, 'fa-minus': allAvailable}" ></i></span>
                              </button>
                            </div>
                            <p class="card-footer-item is-hidden-mobile">
                                <b>Вкупно:</b>
                            </p>
                            <p class="card-footer-item ">
                                <span class="tag is-medium is-light is-rounded">{{getOrder.quantity}} ставки</span>
                            </p>
                            <p class="card-footer-item ">
                                <span class="tag is-medium is-success is-rounded">{{getOrder.total}} ден.</span>
                            </p>
                        </div>
                    </div>

                </div>
                <div class="column is-4-desktop is-full-touch">
                    <div v-show="!orderLoading">
                        <NewOrderClient :notFinishedOrder.sync="notFinishedOrder" :orderLoading.sync="orderLoading"
                                        :user="order.user" :order="order" @setOrder="setOrder"/>
                        <FinishOrder v-bind:order="order" v-if="order.user" @newOrder="fetchLast" @setOrder="setOrder"/>
                    </div>
                    <Loading v-show="orderLoading" variant="is-light" height="20"/>
                </div>
            </div>
        </div>
        <NotFinishedOrderForUser :notFinishedOrder.sync="notFinishedOrder" :order.sync="order" v-if="notFinishedOrder"/>
    </section>
</template>
<script>
    import NewOrderClient from "../../components/NewEditOrder/NewOrderClient";
    import FinishOrder from "../../components/NewEditOrder/FinishOrder";
    import EditOrderVariant from "../../components/NewEditOrder/EditOrderVariant";
    import Loading from "../../components/Loading";
    import NotFinishedOrderForUser from "../../components/NewEditOrder/NotFinishedOrderForUser";

    export default {
        name: "NewEditOrder",
        components: {NotFinishedOrderForUser, Loading, EditOrderVariant, NewOrderClient, FinishOrder},
        data() {
            return {
                activeProduct: -1,
                orderLoading: true,
                order: {
                    items: [],
                    shipping_method_id: null,
                },
                notFinishedOrder: false,
                cancelItems: null,
                timeoutItems: null,
                // Set from an item edit until the server answers for it. Meanwhile the
                // local items are the newest, so other saves must not replace them.
                itemsPending: false,
                itemsSave: null,
                saveNow: null,
                itemsCache:[],
                allAvailable:false
            }
        },
        methods: {
            clickProduct(i) {
                this.activeProduct = this.activeProduct !== i ? i : -1;
            },
            setOrder(order) {
                // A discount, comment or status save answers with the server's items,
                // which don't have the edit that is still waiting to be saved yet.
                if (this.itemsPending && order.id === this.order.id)
                    order = {...order, items: this.order.items};
                this.order = order;
            },
            // Sends a waiting item edit right away, e.g. before leaving the page.
            flushItems() {
                if (this.saveNow) {
                    clearTimeout(this.timeoutItems);
                    this.saveNow();
                }
                return this.itemsSave || Promise.resolve();
            },
            setItemQuantity(variant, q) {
                let element = this.order.items.find(a => a.variant_id === variant.id);
                let toSet = 0;
                if (element) {
                    let next = element.quantity + parseInt(q);
                    toSet = next >= 0 ? next : 0;
                } else {
                    if (q < 0) q = 0;
                    toSet = q;
                }
                this.setItem("quantity", toSet, variant)
            },
            setItem(type, value, variant) {
                let element = this.order.items.find(a => a.variant_id === variant.id);
                let q = parseInt(value) || 0;
                q = q > 10000 ? 10000 : q;
                if (element) {
                    element[type] = q;
                } else {
                    element = {
                        order_id: this.order.id,
                        variant_id: variant.id,
                        quantity: type === "quantity" ? q : 0,
                        price: type === "price" ? q : variant.price
                    }
                    this.order.items.push(element);
                }
                clearTimeout(this.timeoutItems);
                if (this.cancelItems) this.cancelItems.cancel();
                this.itemsPending = true;
                // Taken now, not when the timer fires: by then the page may show another order.
                const orderId = this.order.id;
                const items = this.$deepCopy(this.order.items);
                this.saveNow = () => {
                    this.saveNow = null;
                    const cancel = this.cancelItems = this.$http.CancelToken.source();
                    const save = this.itemsSave = this.$http.patch("/orders/" + orderId + "/order_items",
                        {"items": items},
                        {cancelToken: cancel.token})
                        .then(a => {
                            if (!a) return;
                            if (a.data.data.id === this.order.id) this.order = a.data.data;
                            this.$toast({message: "Зачувано", type: "is-success"})
                        }).catch(() => {
                            this.$toast({message: "Грешка", type: "is-danger"})
                        }).finally(() => {
                            if (this.itemsSave === save) this.itemsSave = null;
                            // Done unless a newer edit already took over (cancelled this one or is waiting).
                            if (this.cancelItems === cancel && !this.saveNow) this.itemsPending = false;
                        });
                };
                this.timeoutItems = setTimeout(this.saveNow, 700);

            },
            fetchLast() {
                this.$http.get("/orders/exists_or_create")
                    .then(a => {
                        this.$router.replace({
                            name: "editOrder",
                            params: {orderId: a.data.data.id},
                        });

                        this.order = a.data.data;
                        this.itemsCache = this.$deepCopy(a.data.data.items);
                        this.orderLoading = false;
                    });
            },
            fetchById(id) {
                this.$http.get("/orders/" + id)
                    .then(a => {
                        this.order = a.data.data;
                        this.itemsCache = this.$deepCopy(a.data.data.items);
                        this.orderLoading = false;
                    });
            },

        },
        computed: {

            products: function () {
                return this.$store.getters.getProducts;
            },
            getItemQuantity: function () {
                return variant => {
                    let o = this.order.items.find(a => a.variant_id === variant.id);
                    return o ? o.quantity : 0;
                }
            },
            getItemCalc: function () {
                return product => {
                    return product.variants.reduce((acc, v) => {
                        const item = this.order.items.find(a => a.variant_id === v.id);
                        if (!item) return acc;
                        return {quantity: acc.quantity + item.quantity, sum: acc.sum + item.quantity * item.price}
                    }, {quantity: 0, sum: 0});
                }
            },
            getOrder: function () {
                return this.products.reduce((acc, p) => {
                    const val = this.getItemCalc(p);
                    acc.quantity += val.quantity;
                    acc.total += val.sum;
                    return acc;
                }, {quantity: 0, total: 0});
            },
            getItemPrice: function () {
                return variant => {
                    let o = this.order.items.find(a => a.variant_id === variant.id);
                    return o ? o.price : variant.price;
                }
            },


        },
        watch: {
            $route(to) {
                if (to.name === "createOrder"){
                    this.fetchLast();
                    this.$store.dispatch("getProducts");
                }
            }
        },
        // Leaving within the 700ms would otherwise let the next page load the order before the edit lands.
        beforeRouteUpdate(to, from, next) {
            this.flushItems().finally(() => next());
        },
        beforeRouteLeave(to, from, next) {
            this.flushItems().finally(() => next());
        },
        created() {
            this.$store.dispatch("getProducts");
            const id = this.$route.params.orderId;
            if (id)
                this.fetchById(id)
            else
                this.fetchLast();
        },

    }
</script>
<style scoped>
    .card-header {
        background: rgb(235, 235, 235);
    }

    /* A long product name has to wrap on a phone instead of pushing the totals off the
       screen. Bulma tags are nowrap and a fixed height, and a flex item will not shrink
       below its content until min-width is cleared. */
    .card-header-title {
        min-width: 0;
    }

    .card-header-title .tag {
        white-space: normal;
        height: auto;
        min-height: 2em;
        text-align: left;
        overflow-wrap: anywhere;
    }

    /* The totals stay whole; the name column is the one that gives way. */
    .card-header-icon {
        flex-shrink: 0;
        padding-left: 0;
    }

    /* Same row on a phone: "Вкупно:" is dropped (is-hidden-mobile) and what is left
       gets tighter gaps, so the two totals fit side by side instead of overflowing. */
    @media screen and (max-width: 768px) {
        .card-footer-item {
            padding-left: 0.35rem;
            padding-right: 0.35rem;
        }
    }

    .card-footer-item {
        justify-content: flex-end;
    }
</style>

